import fetch from "auth/FetchInterceptor";

const ProductService = {};

ProductService.getProducts = function (page = 1, headers = {}, params = {}) {
  // Build query string with optional search and category_id
  let url = `/products/?page=${page}`;
  
  if (params.search) {
    url += `&search=${encodeURIComponent(params.search)}`;
  }
  
  if (params.category_id) {
    url += `&category_id=${params.category_id}`;
  }
  
  return fetch({
    url: url,
    method: "get",
    headers: {
      ...headers,
    },
  });
};

ProductService.getProduct = function (productId, language_id) {
  return fetch({
    url: `/products/${productId}/`,
    method: "get",
    headers: {
      "Language-Id": language_id,
    },
  });
};

ProductService.createProduct = function (product) {
  return fetch({
    url: "/products/",
    method: "post",
    data: product,
  });
};

ProductService.updateProduct = function (data, productId) {
  return fetch({
    url: `/products/${productId}/`,
    method: "put",
    data: data,
  });
};

ProductService.deleteProduct = function (productId) {
  return fetch({
    url: `/products/${productId}/`,
    method: "delete",
  });
};

ProductService.setProductStatus = function (productId, status) {
  return fetch({
    url: `/products/${productId}/update-status/`,
    method: "patch",
    data: { status },
  });
};

ProductService.getOptionsValues = function (languageId) {
  return fetch({
    url: "/option-values/",
    method: "get",
    headers: {
      "Language-Id": languageId,
    },
  });
};

export default ProductService;
